// ----------------------------------------------------------------------

const account = {
  displayName: 'Ingrid Johansen',
  email: 'ingrid-johansen@accessibility.com',
  photoURL: '/assets/images/avatars/avatar_default.jpg',
};

export default account;
